<template>
  <q-dialog v-model="confirm" persistent>
    <q-card style="height: 200px; width: 450px">
      <q-card-section class="column">
        <span v-if="!!titulo" style="color: #21324a" class="mensagem-text">{{
          titulo
        }}</span>
        <span v-else style="color: #21324a" class="mensagem-text"
          >Confirmar Exclusão
        </span>
        <q-separator style="height: 1px; background-color: #21324a" />
      </q-card-section>

      <q-card-section style="min-height: 80px">
        <span style="color: #21324a">{{ mensagem }}</span>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn
          label="Confirmar"
          :disabled="desabilitarConfirme"
          no-caps
          icon="done"
          v-close-popup
          style="
            background-color: #21324a;
            border-radius: 8px;
            color: white;
            font-weight: normal;
          "
          @click="$emit('resultado', true)"
        />
        <q-btn
          icon="close"
          no-caps
          label="Cancelar"
          v-close-popup
          style="
            background-color: white;
            border-radius: 8px;
            color: #21324a;
            font-weight: normal;
            border: 1px solid #21324a;
          "
          @click="$emit('resultado', false)"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { watch, ref } from "vue";
export default {
  props: ["mensagem", "exibir", "desabilitarConfirme", "titulo"],
  setup(props) {
    const confirm = ref(false);

    watch(
      () => props.exibir,
      () => {
        confirm.value = props.exibir;
      }
    );
    return {
      confirm,
    };
  },
};
</script>

<style scoped>
.mensagem-text {
  font-weight: bold;
  font-size: 18px;
}
</style>
